import types from "../types";

const actions = {
  // Login
  login: (data) => {
    return { type: types.LOGIN, payload: data };
  },

  logout: { type: types.LOGOUT },
};

export default actions;
